import { render, staticRenderFns } from "./DayoffDateReduceEditor.vue?vue&type=template&id=061e4257"
import script from "./DayoffDateReduceEditor.vue?vue&type=script&lang=js"
export * from "./DayoffDateReduceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports